module.exports = __webpack_public_path__ + "static/media/vertical-ellipsis-active.96793246.svg";